import { SortDirection } from 'components/Table/types';

export const sortOptions = [
  {
    label: 'Status Published',
    value: { field: 'state_id', order: SortDirection.DESC },
  },
  {
    label: 'Status Draft',
    value: { field: 'state_id', order: SortDirection.ASC },
  },
  {
    label: 'First updated',
    value: { field: 'updated_at', order: SortDirection.ASC },
  },
  {
    label: 'Last updated',
    value: { field: 'updated_at', order: SortDirection.DESC },
  },
  {
    label: 'Version number (old - new)',
    value: { field: 'number', order: SortDirection.ASC },
  },
  {
    label: 'Version number (new - old)',
    value: { field: 'number', order: SortDirection.DESC },
  },
  { label: 'Active', value: { field: 'active', order: SortDirection.DESC } },
  {
    label: 'Inactive',
    value: { field: 'active', order: SortDirection.ASC },
  },
  {
    label: 'Locked',
    value: { field: 'locked', order: SortDirection.DESC },
  },
  {
    label: 'Unlocked',
    value: { field: 'locked', order: SortDirection.ASC },
  },
];
